import { useBreakpoint, Box, Paragraph, Divider, Text } from '@landr/maestro';
import React from 'react';
import { Trans } from '@lingui/macro';
import { useAppConfig } from '@landr/mfe';

export const _TakeDownInfo = ({ isSmall }: { isSmall: boolean }) => {
    const { links } = useAppConfig();
    const supportLink = links.supportLink.originUrl;

    return (
        <>
            <Box
                maxWidth="780px"
                mt={isSmall ? undefined : 'mg'}
                pt={isSmall ? undefined : 'xs'}
            >
                <Paragraph textStyle={isSmall ? 'xl' : '3xl'} fontWeight="bold">
                    <Trans>Sorry, this content has been removed</Trans>
                </Paragraph>
                <Text color="text.medium" textStyle={isSmall ? 'sm' : 'lg'}>
                    <Trans>
                        This content has been removed and is no longer available
                        for purchase. If you’ve previously downloaded it and are
                        unable to re-download,{' '}
                        <Text
                            color="text.high"
                            textStyle={isSmall ? 'sm' : 'lg'}
                        >
                            <a
                                href={supportLink}
                                target="_blank"
                                text-decoration="underline"
                            >
                                please contact support.
                            </a>
                        </Text>
                    </Trans>
                </Text>
            </Box>
            <Box pt={isSmall ? 'jb' : 'mg'} pb={isSmall ? undefined : 'xl'}>
                <Divider />
            </Box>
        </>
    );
};

type TakeDownInfoSize = 'small' | 'base';

export const getTakeDownInfoIsSmall = (
    size: TakeDownInfoSize,
    isMobile: boolean,
) => {
    const isSmall = isMobile || size === 'small';

    return isSmall;
};

const TakeDownInfo = ({ size = 'base' }: { size?: TakeDownInfoSize }) => {
    const isMobile = useBreakpoint('md');
    const isSmall = getTakeDownInfoIsSmall(size, isMobile);

    return <_TakeDownInfo isSmall={isSmall} />;
};

export default TakeDownInfo;
